// (function () {
// 	function featuredCollectionSlider() {
// 		const sliders = document.querySelectorAll(".collection-slider");

// 		if (sliders.length) {
// 			sliders.forEach(slider => {
// 				const id = slider.dataset.sectionId,
// 					centeredSlide = (slider.dataset.centeredSlide == 'true'),
// 					centeredSlides = slider.dataset.centeredSlides === 'true' ? true : false,
// 					columnsMobile = slider.dataset.columnsMobile ? slider.dataset.columnsMobile : 1,
// 					columnsDesktop = slider.dataset.columnsDesktop ? slider.dataset.columnsDesktop : 2;

// 				let tabletSlides = 2;
// 				let proTabletSlides = 2;
// 				initialSlide = 0;
// 				if(centeredSlide == true) {
// 					tabletSlides = 2.4;
// 					proTabletSlides = 2.8;
// 					initialSlide = 1;
// 				}

// 				const swiperfeaturedCollectionSlider = new Swiper(`.collection-slider-${id}`, {
// 					loop: true,
// 					centeredSlides: false,
// 					initialSlide: 0,
// 					slidesPerView: columnsMobile,
// 					slideToClickedSlide: false,
// 					spaceBetween: 20,
// 					grabCursor: true,
// 					longSwipesMs: 500,
// 					longSwipesRatio: 1,
// 					navigation: {
// 						nextEl: `.collection-slider-${id} .slider-arrow-next`,
// 						prevEl: `.collection-slider-${id} .slider-arrow-prev`,
// 					},
// 					breakpoints: {
// 						750: {
// 							loop: false,
// 							// centeredSlides: centeredSlide,
// 							slidesPerView: tabletSlides
// 						},
// 						990: {
// 							centeredSlides,	
// 							slidesPerView: proTabletSlides
// 						},
// 						1099: {
// 							loop: true,
// 							initialSlide: 0,
// 							centeredSlides,
// 							slidesPerView: columnsDesktop,
// 							spaceBetween: 30
// 						}
// 					}
// 				});

// 				const btnPrev = document.querySelector(`#shopify-section-${id} .featured-collection-header .slider-arrow-prev`);
// 					const btnNext = document.querySelector(`#shopify-section-${id} .featured-collection-header .slider-arrow-next`);

// 					if (btnNext) {
// 						btnNext.addEventListener('click', () => swiperfeaturedCollectionSlider.slideNext());
// 					}

// 					if (btnPrev) {
// 						btnPrev.addEventListener('click', () => swiperfeaturedCollectionSlider.slidePrev());
// 					}
// 			});
// 		}
// 	}

// 	document.addEventListener('DOMContentLoaded', featuredCollectionSlider);
// 	document.addEventListener('shopify:section:load', featuredCollectionSlider);
// 	window.addEventListener('resize', featuredCollectionSlider);
// })();

class FeaturedCollectionSlider {
	constructor(sliderElement) {
	  this.sliderElement = sliderElement;
	  this.id = sliderElement.dataset.sectionId;
	  this.centeredSlide = sliderElement.dataset.centeredSlide === 'true';
	  this.centeredSlides = sliderElement.dataset.centeredSlides === 'true';
	  this.columnsMobile = parseInt(sliderElement.dataset.columnsMobile || 1, 10);
	  this.columnsDesktop = parseInt(sliderElement.dataset.columnsDesktop || 2, 10);
  
	  this.initSlider();
	  this.attachNavigationHandlers();
	}
  
	initSlider() {
	  const tabletSlides = this.centeredSlide ? 2.4 : 2;
	  const proTabletSlides = this.centeredSlide ? 2.8 : 2;
	  const initialSlide = this.centeredSlide ? 1 : 0;
  
	  this.swiper = new Swiper(`.collection-slider-${this.id}`, {
		loop: true,
		centeredSlides: false,
		initialSlide: initialSlide,
		slidesPerView: this.columnsMobile,
		slideToClickedSlide: false,
		spaceBetween: 20,
		grabCursor: true,
		longSwipesMs: 500,
		longSwipesRatio: 1,
		navigation: {
		  nextEl: `.collection-slider-${this.id} .slider-arrow-next`,
		  prevEl: `.collection-slider-${this.id} .slider-arrow-prev`,
		},
		breakpoints: {
		  750: {
			loop: false,
			slidesPerView: tabletSlides,
		  },
		  990: {
			centeredSlides: this.centeredSlides,
			slidesPerView: proTabletSlides,
		  },
		  1099: {
			loop: true,
			initialSlide: 0,
			centeredSlides: this.centeredSlides,
			slidesPerView: this.columnsDesktop,
			spaceBetween: 30,
		  },
		},
	  });
	}
  
	attachNavigationHandlers() {
	  this.btnPrev = document.querySelector(`#shopify-section-${this.id} .featured-collection-header .slider-arrow-prev`);
	  this.btnNext = document.querySelector(`#shopify-section-${this.id} .featured-collection-header .slider-arrow-next`);
  
	  if (this.btnNext) {
		this.nextClickHandler = () => this.swiper.slideNext();
		this.btnNext.addEventListener('click', this.nextClickHandler);
	  }
  
	  if (this.btnPrev) {
		this.prevClickHandler = () => this.swiper.slidePrev();
		this.btnPrev.addEventListener('click', this.prevClickHandler);
	  }
	}
  
	destroy() {
	  if (this.btnNext && this.nextClickHandler) {
		this.btnNext.removeEventListener('click', this.nextClickHandler);
	  }
  
	  if (this.btnPrev && this.prevClickHandler) {
		this.btnPrev.removeEventListener('click', this.prevClickHandler);
	  }
  
	  if (this.swiper) {
		this.swiper.destroy(true, true);
	  }
  
	  this.sliderElement.classList.remove('initialized');
	}
  }
  
  const sliderInstances = new Map();
  
  function initializeFeaturedCollectionSliders() {
	const sliders = document.querySelectorAll('.collection-slider');
  
	sliders.forEach((slider) => {
	  if (!sliderInstances.has(slider)) {
		const instance = new FeaturedCollectionSlider(slider);
		sliderInstances.set(slider, instance);
		slider.classList.add('initialized');
	  }
	});
  }
  
  function destroyAllSliders() {
	sliderInstances.forEach((instance, slider) => {
	  instance.destroy();
	  sliderInstances.delete(slider);
	});
  }
  
  document.addEventListener('DOMContentLoaded', initializeFeaturedCollectionSliders);
  document.addEventListener('shopify:section:load', initializeFeaturedCollectionSliders);
  document.addEventListener('shopify:section:unload', (event) => {
	const slider = event.target.querySelector('.collection-slider');
	if (slider && sliderInstances.has(slider)) {
	  const instance = sliderInstances.get(slider);
	  instance.destroy();
	  sliderInstances.delete(slider);
	}
  });
  
  document.addEventListener('shopify:page:unload', destroyAllSliders);
  